/* eslint-disable consistent-return */
import { formatPrice } from '@helpers/menuItemDetails';
import { storage } from '@utils';

export const handleEnterKeyPress = callback => event => {
  if (event.key === 'Enter') {
    callback();
  }
};

export const getEntityAvailabilities = (availabilityIds, availabilities) => (
  availabilityIds
    ? availabilityIds.map(id => ({
      id: parseInt(id, 10),
      name: availabilities[id]?.name,
    }))
    : []
);

// Get value in cents from input string ( 3010 from '$30.10' or 30.10% )
export const getNumberFromString = value => parseFloat(value.replace('%', '').replace('$', ''), 10) * 10 * 10;

export const getDiscountValue = (type, value) => {
  switch (type) {
    case 'price':
      return `$${(value / 100).toFixed(2)}`;
    case 'discount_amount':
      return `$${(value / 100).toFixed(2)} Off`;
    case 'discount_percent':
      return `${formatPrice(value)}% Off`;
    default:
      return formatPrice(value);
  }
};

export const getSpecialPrice = (price, type, value) => {
  switch (type) {
    case 'price':
      return getNumberFromString(value);
    case 'discount_amount':
      return price - getNumberFromString(value);
    case 'discount_percent':
      return price - (price * (getNumberFromString(value) / 10000));
    default:
      return getNumberFromString(value);
  }
};

export const hasSizesWithNullablePrice = (entitySizes, sizes, selectedSize, discountType, discountValue) => (
  !!entitySizes.find(size => size.name === sizes[selectedSize]?.name
    && getSpecialPrice(size.price, discountType, discountValue) <= 0));

export const clearStorageOnScriptError = () => {
  const url = window.location.host;
  if (!url.includes('localhost')) {
    window.onerror = () => {
      storage.clear();
      window.location.reload();
    };
  }
};

